import React, { useState } from 'react';
import {
    Card, CardHeader, CardBody, Button, Row,
    Label, Form, Col, Modal
} from 'reactstrap';
import { AvField, AvForm } from 'availity-reactstrap-validation';
import { useDispatch } from 'react-redux';
import { addOrUpdateCart, cartProductPreview } from '../../actions/action';
import { setPageLoader } from '../../../../../Redux/order/createOrderSlice';
import { ErrorToast, SuccessToast } from '../../../../../utils/Toaster';

const ProductPreview = ({ showProductPreview, setShowcart, bulkMode }) => {
    const [productPreview, setProductPreview] = useState(null);
    const [modalAddProducts, setmodalAddProducts] = useState(false);
    const [otherProductFields, setOtherProductFields] = useState([]);
    const [isCustomMattress, setIsCustomMattress] = useState(false);
    const [mattressWidth, setMattressWidth] = useState('');
    const [mattressLength, setMattressLength] = useState('');
    const [isGrassCarpet, setIsGrassCarpet] = useState(false);
    const [grassCarpetWidth, setGrassCarpetWidth] = useState('');
    const [grassCarpetLength, setGrassCarpetLength] = useState('');
    const [totalGrassCarpetPrice, setTotalGrassCarpetPrice] = useState('0.00');
    const [installationRequired, setInstallationRequired] = useState(false);
    const [selectedSurfaceType, setSelectedSurfaceType] = useState(null);
    const [selectedSurfaceSku, setSelectedSurfaceSku] = useState(null);


    const dispatch = useDispatch();

    // Calculate square meters (㎡)
    const calculateMattressSquareMeters = () => {
        const w = parseFloat(mattressWidth);
        const h = parseFloat(mattressLength);
        if (!isNaN(w) && !isNaN(h)) {
            const areaInCm = w * h;
            const areaInSquareMeters = areaInCm / 10000; // 1㎡ = 10,000 cm²
            return Number(areaInSquareMeters.toFixed(2));
        }
        return 0;
    };

    // Calculate grass carpet square meters with 5% wastage
    const calculateGrassCarpetSquareMeters = () => {
        const w = parseFloat(grassCarpetWidth);
        const l = parseFloat(grassCarpetLength);
        if (!isNaN(w) && !isNaN(l)) {
            const areaInCm = w * l;
            const areaInSquareMeters = areaInCm;
            const areaWithWastage = areaInSquareMeters * 1.05;
            const TotalArea = areaInSquareMeters + Math.ceil(areaWithWastage * 0.05);
            return Number(TotalArea.toFixed(2));
        }
        return 0;
    };

    // Helper to reset all custom product fields
    const resetCustomProductFields = () => {
        setIsGrassCarpet(false);
        setIsCustomMattress(false);
        setGrassCarpetWidth('');
        setGrassCarpetLength('');
        setMattressWidth('');
        setMattressLength('');
        setOtherProductFields([]);
    };

    const getProductPreview = async (event, values) => {
        resetCustomProductFields();
        event.preventDefault();
        dispatch(setPageLoader(true));
        try {
            const { sku } = values;
            const previewData = await cartProductPreview(
                {
                    id: sku,
                    country: 'ae',
                    language: 'en',
                    showDraft: true,
                    getFamilyVariants: true,
                    fields: [
                        'sale_badge', 'feature_badge', 'market_badge', 'discount_badge',
                        'url_key', 'hello_ar_product_code', 'allow_click_and_collect',
                        'installation_type', 'is_returnable', 'brand', 'color',
                        'pattern_size', 'carpet_size', 'mattress_size', 'dimension',
                        'length_cm', 'width_cm', 'diameter_cm', 'height_cm', 'weight',
                        'country_of_manufacture', 'material', 'warranty', 'pack_size_meter_square',
                        'uom', 'number_of_pcs_box', 'customized_uom', 'tile_family',
                        'grass_carpet_thickness', 'is_fire_retardant', 'uv_protection_period',
                        'is_anti_bacterial', 'is_pet_friendly', 'customized_category',
                        'is_customized', 'is_modular_wardrobe', 'a_plus_content_json',
                        'machine_washable', 'primary_material', 'is_display_piece', 'delivery_method'
                    ],
                },
                dispatch
            );
            if (previewData?.getProductDetailForMobile?._id) {
                const otherFields = {};
                previewData.getProductDetailForMobile?.otherFields?.forEach((other) => {
                    otherFields[other.field_id] = other.value;
                });

                setOtherProductFields(otherFields);

                if (otherFields?.customized_category === 'mattress') {
                    setIsCustomMattress(true);
                    setmodalAddProducts(true);
                }
                else if (otherFields?.customized_category === 'grasscarpet') {
                    setIsGrassCarpet(true);
                    setmodalAddProducts(true);
                }
                else {
                    setmodalAddProducts(false);
                    addToCartQty(event, {
                        sku: previewData.getProductDetailForMobile._id,
                        qty: 1
                    });
                }

                setProductPreview(previewData.getProductDetailForMobile);
            } else {
                ErrorToast('Product details not available');
            }
        } catch (error) {
            ErrorToast('An error occurred while fetching product details.');
            console.error(error);
        } finally {
            dispatch(setPageLoader(false));
        }
    };

    const addToCartQty = async (event, values, cp = null, options = []) => {
        event.preventDefault();
        dispatch(setPageLoader(true));
        try {
            const { sku, qty } = values;
            // Only add mattress params if customized_category is mattress
            let addToCartParams = { sku, qty: Number(qty || 1), cp };
            if (
                otherProductFields?.customized_category === 'mattress' ||
                otherProductFields?.customized_category === 'grasscarpet'
            ) {
                addToCartParams = {
                    ...addToCartParams,
                    width: Number(values.width || mattressWidth || 50),
                    length: Number(values.length || mattressLength || 50),
                    uom: values.uom || 'cm-sqm',
                    options
                };
            }
            const cartUpdated = await addOrUpdateCart(
                addToCartParams,
                dispatch
            );
            if (cartUpdated?._id) {
                setShowcart(true);
                resetCustomProductFields();
                SuccessToast('New item added/updated in cart');
            } else {
                ErrorToast('Requested Qty not available');
            }
        } catch (error) {
            ErrorToast('An error occurred while adding to cart.');
            console.error(error);
        } finally {
            dispatch(setPageLoader(false));
        }
    };

    // Update isCustomMattress effect to set default values
    React.useEffect(() => {
        if (isCustomMattress) {
            setMattressWidth('50');
            setMattressLength('50');
        }
    }, [isCustomMattress]);

    React.useEffect(() => {
        if (isGrassCarpet) {
            setGrassCarpetWidth('10');
            setGrassCarpetLength('3');
        }
    }, [isGrassCarpet]);

    // Calculate grass carpet total price and update state in useEffect
    React.useEffect(() => {
        const w = Number(grassCarpetWidth);
        const l = Number(grassCarpetLength);
        const price = Number(productPreview?.selectedPrice?.specialPrice) || 0;
        if (!isNaN(w) && !isNaN(l) && w > 0 && l > 0 && price > 0) {
            const areaInCm = w * l;
            const areaInSquareMeters = areaInCm;
            const wastage = Math.ceil(areaInSquareMeters * 0.05);
            const totalArea = areaInSquareMeters + wastage;
            const totalPrice = (totalArea * price).toFixed(2);
            setTotalGrassCarpetPrice(totalPrice);
        } else {
            setTotalGrassCarpetPrice('0');
        }
    }, [grassCarpetWidth, grassCarpetLength, productPreview?.selectedPrice?.specialPrice]);

    // When installationRequired or installationOptions change, select default
    React.useEffect(() => {
        if (installationRequired && productPreview?.installationOptions?.length > 0) {
            const defaultOption = productPreview.installationOptions[0];
            setSelectedSurfaceType(defaultOption.id || 0);
            setSelectedSurfaceSku(defaultOption.sku || null);
        } else if (!installationRequired) {
            setSelectedSurfaceType(null);
            setSelectedSurfaceSku(null);
        }
    }, [installationRequired, productPreview?.installationOptions]);


    return !bulkMode && showProductPreview ? (
        <Card>
            <CardHeader>
                <h6>Product Preview</h6>
            </CardHeader>
            <CardBody>
                <Row>
                    <Col md="2">
                        <AvForm onValidSubmit={getProductPreview}>
                            <Row className="align-items-end">
                                <Col>
                                    <AvField
                                        name="sku"
                                        label="SKU*"
                                        type="number"
                                        validate={{
                                            required: {
                                                value: true,
                                                errorMessage: 'Please Enter SKU.',
                                            },
                                        }}
                                    />
                                </Col>
                                <Col xs="auto" className="d-flex mb-1">
                                    <Button type="submit" className="btn btn-dark py-1 px-3 btn-compact">
                                        Add
                                    </Button>
                                </Col>
                            </Row>
                        </AvForm>
                    </Col>
                </Row>
            </CardBody>

            <Modal
                isOpen={modalAddProducts}
                scrollable={true}
                size="xl"
            >
                {isCustomMattress && (<><div className="modal-header border-0">
                    <div>
                        <h4 className="modal-title mt-0">
                            {productPreview?.name}
                        </h4>
                        <p className="text-muted m-0">SKU: {productPreview?._id}</p>
                        <p className="m-0 fs-24 d-flex align-items-center gap-2">
                            <strong className="text-danger fw-bold">
                                {productPreview?.defaultPrice?.currency || 'AED'}{' '}

                                {productPreview?.selectedPrice?.specialPrice}/㎡
                            </strong>
                        </p>
                    </div>
                    <button
                        type="button"
                        onClick={() => setmodalAddProducts(false)}
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                    >
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                    <div className="modal-body pt-0">
                        <Row>
                            <Col md={5} className="mb-3">
                                {productPreview?.media_gallery?.length > 0 ? (
                                    <img
                                        src={productPreview?.media_gallery[0]?.r500}
                                        alt="Product"
                                        className="img-fluid rounded-3"
                                    />
                                ) : (
                                    'No media available'
                                )}
                            </Col>
                            <Col md={7} className="d-flex flex-column gap-4">
                                <div className="border border-light rounded-3 p-3">
                                    <h5>Custom Size</h5>
                                    <Form className="d-flex flex-column gap-3">
                                        <Row>
                                            <>
                                                <Col>
                                                    <Label className="form-label">Width</Label>
                                                    <div className="position-relative border border-light rounded-3 overflow-hidden">
                                                        <input
                                                            className="p-2 border-0 rounded-3 w-100"
                                                            type="number"
                                                            value={mattressWidth}
                                                            onChange={(e) => setMattressWidth(e.target.value)}
                                                        />
                                                        <span className="bg-light position-absolute top-0 end-0 py-2 px-3">
                                                            CM
                                                        </span>
                                                    </div>
                                                </Col>
                                                <Col>
                                                    <Label className="form-label">Length</Label>
                                                    <div className="position-relative border border-light rounded-3 overflow-hidden">
                                                        <input
                                                            className="p-2 border-0 rounded-3 w-100"
                                                            type="number"
                                                            value={mattressLength}
                                                            onChange={(e) => setMattressLength(e.target.value)}
                                                        />
                                                        <span className="bg-light position-absolute top-0 end-0 py-2 px-3">
                                                            CM
                                                        </span>
                                                    </div>
                                                </Col>
                                            </>
                                        </Row>
                                        <Row>
                                            <Col>
                                                <p className="m-0">
                                                    Mattress Size :{' '}
                                                    <strong>
                                                        W {mattressWidth} x L {mattressLength} ({calculateMattressSquareMeters()} ㎡)
                                                    </strong>
                                                </p>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col>
                                                <p className="m-0 p-2 bg-soft-warning text-dark rounded-3 fs-12 text-center">
                                                    This item is already available in predefined size
                                                </p>
                                            </Col>
                                        </Row>
                                    </Form>
                                </div>
                                <div className="d-flex flex-column gap-3">
                                    <p className="m-0 fs-24 d-flex align-items-center gap-2">
                                        <strong className="text-danger fw-bold">
                                            {productPreview?.defaultPrice?.currency || 'AED'}{' '}
                                            {isCustomMattress
                                                ? (productPreview?.selectedPrice?.specialPrice * calculateMattressSquareMeters()).toFixed(2)
                                                : productPreview?.selectedPrice?.specialPrice}
                                        </strong>

                                        {productPreview?.selectedPrice?.specialPrice !== productPreview?.defaultPrice?.specialPrice && (
                                            <>
                                                <del className="text-black-50 opacity-1 fw-light">
                                                    {productPreview?.defaultPrice?.specialPrice}
                                                </del>
                                                {/* <small className="text-success fs-12">
                                                    26% OFF - Saved AED 536
                                                </small> */}
                                            </>
                                        )}
                                    </p>

                                    <div className="d-flex flex-column align-items-start gap-2">
                                        <p className="m-0">
                                            {productPreview?.inventoryStock?.inStock ? (<>Availability :{' '}
                                                <strong className="text-success">In-stock</strong></>) : (<>Availability :{' '}
                                                    <strong className="text-danger">Out of stock</strong></>)}

                                        </p>
                                        <Button
                                            color="dark"
                                            onClick={(e) => {
                                                addToCartQty(
                                                    e,
                                                    {
                                                        sku: productPreview?._id,
                                                        qty: 1,
                                                        width: mattressWidth,
                                                        height: mattressLength,
                                                        uom: productPreview?.uom
                                                    }
                                                );
                                                setmodalAddProducts(false);
                                            }}
                                            disabled={!mattressWidth || !mattressLength}
                                        >
                                            Add to Basket
                                        </Button>
                                    </div>
                                </div>
                                <Row>
                                    <Col md={12} className="d-flex flex-column gap-4 border border-light rounded-3 p-3">
                                        <div className="d-flex flex-row align-items-center">
                                            <span className="me-3">
                                                <img src="https://assets.danubehome.com/media/assets/svg-v2/customized.svg" alt="" width="52" height="53" />
                                            </span>
                                            <div>
                                                <strong>Customized Product. It cannot be canceled, exchanged or returned.</strong><br />
                                                <i>Note: Products can be cancelled only in case of any manufacturing defect. Once ordered, they can’t be cancelled, returned, or exchanged.</i>
                                            </div>
                                        </div>

                                    </Col>
                                </Row>
                            </Col>

                        </Row>
                    </div></>)}

                {
                    isGrassCarpet && (<><div className="modal-header border-0">
                        <div>
                            <h4 className="modal-title mt-0">
                                {productPreview?.name}
                            </h4>
                            <p className="text-muted m-0">SKU: {productPreview?._id}</p>
                            <p className="m-0 fs-24 d-flex align-items-center gap-2">
                                <strong className="text-danger fw-bold">
                                    {productPreview?.defaultPrice?.currency || 'AED'}{' '}

                                    {productPreview?.selectedPrice?.specialPrice}/㎡
                                </strong>
                            </p>

                        </div>
                        <button
                            type="button"
                            onClick={() => setmodalAddProducts(false)}
                            className="close"
                            data-dismiss="modal"
                            aria-label="Close"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                        <div className="modal-body pt-0">
                            <Row>
                                <Col md={5} className="mb-3">
                                    {productPreview?.media_gallery?.length > 0 ? (
                                        <img
                                            src={productPreview?.media_gallery[0]?.r500}
                                            alt="Product"
                                            className="img-fluid rounded-3"
                                        />
                                    ) : (
                                        'No media available'
                                    )}
                                </Col>
                                <Col md={7} className="d-flex flex-column gap-4">
                                    <div className="border border-light rounded-3 p-3">
                                        <h5>Custom Size</h5>
                                        <Form className="d-flex flex-column gap-3">
                                            <Row>
                                                <>
                                                    <Col>
                                                        <Label className="form-label">Width</Label>
                                                        <div className="position-relative border border-light rounded-3 overflow-hidden">
                                                            <input
                                                                className="p-2 border-0 rounded-3 w-100"
                                                                type="number"
                                                                value={grassCarpetWidth}
                                                                onChange={(e) => setGrassCarpetWidth(e.target.value)}
                                                            />
                                                            <span className="bg-light position-absolute top-0 end-0 py-2 px-3">
                                                                Meter
                                                            </span>
                                                        </div>
                                                    </Col>
                                                    <Col>
                                                        <Label className="form-label">Length</Label>
                                                        <div className="position-relative border border-light rounded-3 overflow-hidden">
                                                            <input
                                                                className="p-2 border-0 rounded-3 w-100"
                                                                type="number"
                                                                value={grassCarpetLength}
                                                                onChange={(e) => setGrassCarpetLength(e.target.value)}
                                                            />
                                                            <span className="bg-light position-absolute top-0 end-0 py-2 px-3">
                                                                Meter
                                                            </span>
                                                        </div>
                                                    </Col>
                                                </>
                                            </Row>
                                            <Row>
                                                <Col>
                                                    <p className="m-0">
                                                        {(() => {
                                                            const w = Number(grassCarpetWidth);
                                                            const l = Number(grassCarpetLength);
                                                            if (!isNaN(w) && !isNaN(l) && grassCarpetWidth !== '' && grassCarpetLength !== '') {
                                                                const areaInCm = w * l;
                                                                const areaInSquareMeters = areaInCm;
                                                                const wastage = Math.ceil(areaInSquareMeters * 0.05);
                                                                const totalArea = areaInSquareMeters + wastage;
                                                                // Use toFixed(2) for decimals instead of Math.round
                                                                return `Total area: ${totalArea.toFixed(2)}㎡ (${areaInSquareMeters.toFixed(2)}㎡ + 5% wastage: ${wastage.toFixed(2)}㎡)`;
                                                            }
                                                            return 'Total area : 0㎡ (0㎡ + 5% wastage: 0㎡)';
                                                        })()}
                                                    </p>
                                                </Col>
                                            </Row>

                                            <Row>
                                                <Col>
                                                    <p className="m-0 p-2 bg-soft-light text-dark rounded-3 fs-12 text-center">
                                                        <strong className='text-danger fw-bold fs-24'>
                                                            {productPreview?.selectedPrice?.currency || ''} {totalGrassCarpetPrice}
                                                        </strong>
                                                    </p>
                                                </Col>
                                            </Row>
                                        </Form>
                                    </div>
                                    <div className="border border-light rounded-3 p-3 d-flex flex-column gap-3">
                                        {/* Toggle button for installation required */}
                                        <div className="d-flex flex-column gap-0">
                                            <div className="form-check form-switch fs-20 mb-0">
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    id="installationRequiredSwitch"
                                                    checked={installationRequired}
                                                    onChange={() => setInstallationRequired(!installationRequired)}
                                                />
                                                <label className="form-check-label" htmlFor="installationRequiredSwitch">
                                                    Do you want Installation
                                                </label>
                                            </div>
                                            <div className="form-check form-switch ps-0 mb-0">
                                                <p className="m-0">
                                                    Installation fees are determined based on your surface type
                                                </p>
                                            </div>
                                        </div>
                                        {/* Show installation options only if toggle is enabled */}
                                        {installationRequired && (
                                            <>
                                                <div className="d-flex flex-column gap-1">
                                                    <h5 className="m-0">
                                                        Installation based on your surface type
                                                    </h5>
                                                    <p className="m-0">
                                                        Note: Installation fees are determined based on your surface
                                                        type.
                                                    </p>
                                                </div>
                                                <div className="d-flex flex-column gap-2">
                                                    {productPreview?.installationOptions && productPreview?.installationOptions.map((option, idx) => (
                                                        <div className="border border-light bg-soft-light rounded-3 px-3 py-2" key={option.id || idx}>
                                                            <div className="d-flex flex-row gap-2 form-check form-switch form-switch-md w-100 justify-content-center align-items-center">
                                                                <input
                                                                    type="radio"
                                                                    className="form-check-input p-0 radio-sm"
                                                                    name="surfaceType"
                                                                    id={`surfaceType_${option.id || idx}`}
                                                                    checked={selectedSurfaceType === (option.id || idx)}
                                                                    onChange={() => {
                                                                        setSelectedSurfaceType(option.id || idx);
                                                                        setSelectedSurfaceSku(option.sku || null);
                                                                    }}
                                                                />
                                                                <label
                                                                    className="form-check-label w-100 d-flex flex-row justify-content-between align-items-center"
                                                                    htmlFor={`surfaceType_${option.id || idx}`}
                                                                >
                                                                    <span className="d-flex flex-column">
                                                                        <span>{option.name} ({option.price} m²)</span>
                                                                        <span className='fw-normal'>Grass Carpet {option.name} Installation Fee</span>
                                                                    </span>
                                                                    <span className="fs-18">
                                                                        <strong className="text-dark fw-bold">
                                                                            {option.currency.toUpperCase()} {calculateGrassCarpetSquareMeters() * option.price}
                                                                        </strong>
                                                                    </span>
                                                                </label>
                                                            </div>
                                                        </div>
                                                    ))}
                                                    <p className="m-0 fs-24 d-flex align-items-center gap-2">
                                                        <strong className="text-danger fw-bold">
                                                            {productPreview?.defaultPrice?.currency || 'AED'}{' '}
                                                            {/* Use selected option's price if selected, else fallback */}
                                                            {(() => {
                                                                if (installationRequired && selectedSurfaceType !== null && productPreview?.installationOptions) {
                                                                    const selectedOption = productPreview.installationOptions.find((option, idx) => (option.id || idx) === selectedSurfaceType);
                                                                    if (selectedOption) {
                                                                        return ((parseFloat(totalGrassCarpetPrice) || 0) + (calculateGrassCarpetSquareMeters() * selectedOption.price)).toFixed(2);
                                                                    }
                                                                }

                                                            })()}
                                                        </strong>
                                                        <>
                                                            <small className="text-success fs-12">
                                                                Inclusive of Total Price + Installation Fee
                                                            </small>
                                                        </>
                                                    </p>
                                                </div>
                                            </>
                                        )}
                                    </div>
                                    <div className="d-flex flex-column gap-3">
                                        <div className="d-flex flex-column align-items-start gap-2 mb-3">
                                            <Button
                                                color="dark"
                                                onClick={(e) => {
                                                    addToCartQty(
                                                        e,
                                                        {
                                                            sku: productPreview?._id,
                                                            qty: 1,
                                                            width: grassCarpetWidth,
                                                            length: grassCarpetLength,
                                                            uom: 'm-sqm',
                                                        },
                                                        null,
                                                        installationRequired && selectedSurfaceSku ? [selectedSurfaceSku] : []
                                                    );
                                                    setmodalAddProducts(false);
                                                }}
                                                disabled={!grassCarpetWidth || !grassCarpetLength}
                                            >
                                                Add to Basket
                                            </Button>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </div></>)
                }
            </Modal >

        </Card >
    ) : null;
};

export default ProductPreview;
